import { calculateTextExprValue, getCnFormatPlugin, judgeCnFormatExist, } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnReadOnly } from '@cainiaofe/cn-ui';
import isPlainObject from 'lodash/isPlainObject';
import { handleRequestParams } from '@/common/util/request';
import qs from 'query-string';
import omit from 'lodash/omit';
import CnFormatAlc from '@/lowcode/cn-format-alc';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
    ],
    componentName: 'ReadOnly',
    formComponent: (props) => {
        const { getRequestParams, getFormItemConfig, ...rest } = props || {};
        const extraProps = {};
        const formItemConfig = getFormItemConfig?.();
        const _params = getRequestParams?.();
        if (isPlainObject(formItemConfig)) {
            const { options = {} } = formItemConfig;
            const { format, text, url, urlParams, formatOptions } = options;
            const tempPlugin = getCnFormatPlugin({ name: format });
            if (format === 'style-text') {
                extraProps.type = 'tableCell';
                extraProps.tableCellProps = {
                    format: 'text',
                    tableCellItem: rest?.value,
                };
            }
            else if (format === 'text') {
                const realText = calculateTextExprValue(text, _params) || rest?.value;
                let realUrl = calculateTextExprValue(url, _params);
                const realParams = qs.stringify(handleRequestParams(urlParams, _params));
                if (realUrl && realUrl.indexOf('?') !== -1) {
                    realUrl += `&${realParams}`;
                }
                else if (realParams) {
                    realUrl += `?${realParams}`;
                }
                extraProps.type = 'tableCell';
                extraProps.tableCellProps = {
                    format,
                    tableCellItem: {
                        text: realText,
                        link: realUrl,
                    },
                };
            }
            else if ([
                'progress',
                'tag',
                'percent',
                'multiple-text',
                'currency',
                'currency-with-unit',
            ].includes(format)) {
                extraProps.type = 'tableCell';
                extraProps.tableCellProps = {
                    format,
                    tableCellItem: rest?.value,
                };
                if (format === 'percent' ||
                    format === 'currency' ||
                    format === 'currency-with-unit') {
                    extraProps.tableCellProps.column = {
                        align: 'left',
                    };
                }
                if (format === 'multiple-text') {
                    extraProps.value = undefined;
                }
            }
            else if (tempPlugin || judgeCnFormatExist(format)) {
                const { recordDataSource, _context } = _params || {};
                let formatSchema = [];
                let extraOptions = {};
                if (format === 'CnFormatArrayView2') {
                    formatSchema = formatOptions?.formatSchema;
                    extraOptions = omit(formatOptions, ['formatSchema']);
                }
                else {
                    formatSchema = [
                        {
                            format,
                            options: formatOptions,
                        },
                    ];
                }
                return (<CnFormatAlc formatSchema={formatSchema} {...extraOptions} _context={_params?._context} __getContextData__={() => {
                        return {
                            functionArg: {
                                item: recordDataSource,
                                index: 0,
                                state: _context?.state,
                                _context,
                                value: props?.value,
                            },
                        };
                    }}/>);
            }
        }
        return <CnReadOnly {...rest} {...extraProps}/>;
    },
    formItemBeforeHandler: (formItem, config) => {
        const { urlParams, formValue, state, formItemConfig, _context } = config;
        if (formItem) {
            formItem['x-component-props'].getRequestParams = () => {
                return {
                    urlParamsDataSource: urlParams,
                    recordDataSource: formValue,
                    state,
                    _context,
                };
            };
            formItem['x-component-props'].getFormItemConfig = () => {
                return formItemConfig;
            };
        }
    },
};
